import React, { Component } from 'react';
import PaymentButton from './PaymentButton';
import EstimatorNavBar from '../components/EstimatorNavBar';
import {
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
  Button
} from 'react-bootstrap';
import { Auth, API } from 'aws-amplify';
import './Upgrade.css';

export default class Upgrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isProcessingPayment: false,
      subscription: 'personal-yearly',
      username: '',
      /* desiredType: 'Enterprise', */
      comments: ''
    };
  }

  async componentDidMount() {
    this.getUsername();
  }

  handleSubmit = async event => {
    event.preventDefault();

    let user = await Auth.currentAuthenticatedUser();
    try {
      await this.sendEnquiry({
        name: user.attributes['custom:name'],
        email: user.attributes['email'],
        company: user.attributes['custom:company'],
        country: user.attributes['custom:country'],
        desiredType: 'Enterprise',
        comments: this.state.comments
      });
      alert(
        'Thank you for your enquiry. The Digimasters team will be in touch shortly.'
      );
      this.props.history.push('/beta');
    } catch (e) {
      console.error(e);
    }
  };

  sendEnquiry(enquiry) {
    return API.post('va-estimator', '/va-estimator/enquire', {
      body: enquiry
    });
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  getUsername = async event => {
    try {
      await Auth.currentAuthenticatedUser().then(data =>
        this.setState({ username: data.attributes.email })
      );
    } catch (e) {
      alert(e);
    }
  };

  handleSuccess = result => {
    alert('Your account has been successfully upgraded.');
    console.log(result);
    this.props.setAccountType();
    this.props.history.push('/beta');
  };

  handleFailure = error => {
    alert(
      'Something has gone wrong and your subscription has not been processed.'
    );
    console.error(error);
  };

  setProcessing() {
    this.setState({ isProcessingPayment: true });
  }

  renderPaymentButton() {
    if (this.state.subscription === 'personal-yearly') {
      return (
        <PaymentButton
          successCallback={this.handleSuccess}
          failureCallback={this.handleFailure}
          url="personalyearlysub"
          amount={15999}
          username={this.state.username}
          startProcessingCallback={this.setProcessing.bind(this)}
        />
      );
    } else if (this.state.subscription === 'personal-monthly') {
      return (
        <PaymentButton
          successCallback={this.handleSuccess}
          failureCallback={this.handleFailure}
          url="personalmonthlysub"
          amount={1399}
          username={this.state.username}
          startProcessingCallback={this.setProcessing.bind(this)}
        />
      );
    } else if (this.state.subscription === 'student-yearly') {
      if (
        this.state.username.endsWith('.ac.uk') ||
        this.state.username.endsWith('.edu')
      ) {
        return (
          <PaymentButton
            successCallback={this.handleSuccess}
            failureCallback={this.handleFailure}
            url="studentpersonalyearlysub"
            amount={7499}
            username={this.state.username}
            startProcessingCallback={this.setProcessing.bind(this)}
          />
        );
      } else {
        return (
          <p>
            You must have a recognised student email address in order to sign up
            for this subscription.
          </p>
        );
      }
    } else if (this.state.subscription === 'student-monthly') {
      if (
        this.state.username.endsWith('.ac.uk') ||
        this.state.username.endsWith('.edu')
      ) {
        return (
          <PaymentButton
            successCallback={this.handleSuccess}
            failureCallback={this.handleFailure}
            url="studentpersonalmonthlysub"
            amount={699}
            username={this.state.username}
            startProcessingCallback={this.setProcessing.bind(this)}
          />
        );
      } else {
        return (
          <p>
            You must have a recognised student email address in order to sign up
            for this subscription.
          </p>
        );
      }
    } else if (this.state.subscription === 'enterprise') {
      return (
        <form onSubmit={this.handleSubmit}>
          <h3>Contact Digimasters</h3>
          <p>
            Enterprise account features are still in development. If you are
            interested in upgrading to an Enterprise account, please get in
            touch with the form below:
          </p>
          <FormGroup controlId="desiredType">
            <ControlLabel>
              Interested In Upgrading To:{' '}
              <span className="emphasis">Enterprise</span>
            </ControlLabel>
          </FormGroup>
          <FormGroup controlId="comments">
            <ControlLabel>Comments:</ControlLabel>
            <FormControl
              componentClass="textarea"
              placeholder=""
              onChange={this.handleChange}
              value={this.state.comments}
            />
          </FormGroup>
          <Button bsStyle="success" bsSize="large" type="submit">
            Submit
          </Button>
        </form>
      );
    }
  }

  renderUpgradeForm() {
    if (this.state.isProcessingPayment) {
      return (
        <Col>
          <h1>Processing payment, please wait a few seconds...</h1>
        </Col>
      );
    } else {
      return (
        <Col xs={8} md={4}>
          <FormGroup controlId="subscription">
            <ControlLabel>Choose Subscription:</ControlLabel>
            <FormControl
              componentClass="select"
              onChange={this.handleChange}
              value={this.state.subscription}
              type="string">
              <option value="personal-yearly">Personal (£159.99/Year)</option>
              <option value="personal-monthly">Personal (£13.99/Month)</option>
              <option value="student-yearly">Student (£74.99/Year)</option>
              <option value="student-monthly">Student (£6.99/Month)</option>
              <option value="enterprise">Enterprise</option>
            </FormControl>
          </FormGroup>
          {this.renderPaymentButton()}
        </Col>
      );
    }
  }

  renderDefaultMessage() {
    return (
      <div>
        <p>
          Thank you for upgrading to a{' '}
          <span className="emphasis">Personal</span> account.
        </p>
        <p>
          For more information, please access your{' '}
          <span className="emphasis">Profile</span> from the top menu.
        </p>
      </div>
    );
  }

  render() {
    return (
      <div className="upgrade">
        <EstimatorNavBar
          isAuthenticated={this.props.isAuthenticated}
          appLogout={this.props.appLogout}
          accountType={this.props.accountType}
          hideUpgradeLink={true}
        />
        {this.props.accountType === 'free'
          ? this.renderUpgradeForm()
          : this.renderDefaultMessage()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Upgrade.js